import React, { Component } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import {
  PageHeader,
  CustomPanel,
  CustomCheckbox,
  Loading,
  CustomDataTableHeader,
  ThreeDots,
} from '../../../../components'
import { showMessageBox } from '../../../../store/actions/system.actions'
import * as UsuarioHttp from '../../../../services/api/https/settings/user.http'
import { isRouteAllowed } from '../../../../services/permission/menus'
import { getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import ModalEditarUsuarioTpAdmin from './ModalEditarUsuarioTpAdmin/ModalEditarUsuarioTpAdmin'

class GestaoUsuarios extends Component {
  state = {
    isLoanding: true,
    usuarios: [],
    globalFilter: '',
    showModalEditarUsuario: false,
    usuarioSelecionado: null,
  }
  onBtnVoltar = () => {
    this.props.history.goBack()
  }
  onToggleAtivo = async usuario => {
    try {
      const { id: userId } = getUsuarioInfo()
      const updatedUsuario = await UsuarioHttp.userToggleActivedTpAdmin(
        usuario.id,
        this.props.selectedTp,
        userId,
      )
      this._updateUsuarios(updatedUsuario)
    } catch (error) {
      this.props.dispatch(showMessageBox(null, error))
    }
  }
  onThreeDotsClicked = (menuItem, usuario) => {
    switch (String(menuItem)) {
      case 'Editar Usuário':
        this.setState({ showModalEditarUsuario: true, usuarioSelecionado: usuario })
        break
      default:
        console.error('Opção do Menu não identificada !')
        break
    }
  }
  onModalEditarUsuarioSave = usuario => {
    this._updateUsuarios(usuario)
    this.setState({ showModalEditarUsuario: false })
  }
  componentDidMount = async () => {
    if (!this.props.selectedTp) {
      this.props.dispatch(showMessageBox(null, 'Selecione um TP'))
      this.setState({ isLoanding: false, usuarios: [] })
      return
    }
    try {
      const { id: userId } = getUsuarioInfo()
      const usuarios = await UsuarioHttp.getUsersAllByTp(this.props.selectedTp, userId)
      this.setState({ isLoanding: false, usuarios })
    } catch (error) {
      this.props.dispatch(showMessageBox(null, error))
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.selectedTp !== this.props.selectedTp) {
      if (!this.props.selectedTp) {
        this.setState({ usuarios: [], isLoanding: false })
        this.props.dispatch(showMessageBox(null, 'Selecione um TP'))
      } else {
        this.setState({ isLoanding: true })
        const { id: userId } = getUsuarioInfo()
        UsuarioHttp.getUsersAllByTp(this.props.selectedTp, userId)
          .then(usuarios => this.setState({ usuarios, isLoanding: false }))
          .catch(error => {
            this.props.dispatch(showMessageBox(null, error))
            this.setState({ isLoanding: false, usuarios: [] })
          })
      }
    }
  }

  render() {
    if (!isRouteAllowed(45))
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
          }}
        >
          <h1>Você não tem acesso a esta funcionalidade</h1>
        </div>
      )
    const { isLoanding, showModalEditarUsuario, usuarioSelecionado } = this.state
    return (
      <div>
        <PageHeader>2.16 - Gestão de Usuários</PageHeader>
        <div style={{ marginTop: 20 }}>
          <CustomPanel showBtnNovo={false} onVoltar={this.onBtnVoltar}>
            {isLoanding ? (
              <div className="text-center">
                <Loading size="md" />
              </div>
            ) : (
              this._dataTable()
            )}
          </CustomPanel>
        </div>
        {showModalEditarUsuario && (
          <ModalEditarUsuarioTpAdmin
            usuario={usuarioSelecionado}
            show={showModalEditarUsuario}
            onModalClose={() => this.setState({ showModalEditarUsuario: false })}
            onModalSave={this.onModalEditarUsuarioSave}
          />
        )}
      </div>
    )
  }

  _dataTable = () => {
    return (
      <DataTable
        value={this.state.usuarios}
        rows={10}
        paginator
        globalFilter={this.state.globalFilter}
        header={
          <CustomDataTableHeader onChange={value => this.setState({ globalFilter: value })} />
        }
      >
        <Column field="id" header="Código" style={{ textAlign: 'center', width: 80 }} />
        <Column field="name" header="Usuário" />
        <Column field="email" header="E-mail" />
        <Column
          field="actived"
          header="Ativo"
          style={{ textAlign: 'center', width: 100 }}
          body={(rowData, column) => (
            <CustomCheckbox
              checked={rowData.actived}
              onChange={() => this.onToggleAtivo(rowData)}
            />
          )}
        />
        <Column
          header="Menu"
          style={{ textAlign: 'center', width: 80 }}
          body={(rowData, column) => (
            <ThreeDots
              items={['Editar Usuário']}
              onClick={menuItem => this.onThreeDotsClicked(menuItem, rowData)}
            />
          )}
        />
      </DataTable>
    )
  }
  _updateUsuarios = usuario => {
    this.setState(state => {
      const { usuarios } = state
      const index = usuarios.findIndex(l => l.id === usuario.id)
      index !== -1 ? (usuarios[index] = usuario) : usuarios.push(usuario)
      return { usuarios }
    })
  }
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(GestaoUsuarios))
